export default __webpack_public_path__ + "static/images/5342d78c.png";